export const isSpidLoggedIn = (workspace: { onboarding?: { spid_logged_in?: boolean } } = {}): boolean => {
  const { onboarding = {} } = workspace;
  const { spid_logged_in = false } = onboarding;
  return spid_logged_in;
};
